export const fadeTransitionVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -20 }
};

export const slideTransitionVariants = {
  initial: { opacity: 0, x: -20 },
  in: { opacity: 1, x: 0 },
  out: { opacity: 0, x: 20 }
};

export const scaleTransitionVariants = {
  initial: { opacity: 0, scale: 0.9 },
  in: { opacity: 1, scale: 1 },
  out: { opacity: 0, scale: 1.1 }
};

export const createButtonPress = () => ({
  whileTap: { scale: 0.95 },
  whileHover: { scale: 1.05 },
  transition: { duration: 0.1 }
});
